import { createRef, Component, Fragment } from "react";
import axios from "axios";
import { axiosConfig, ValidateEmail, normalize } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  addNewClient,
  getAgentPermissionData,
  getClientMenuActiveGroups,
} from "./../../../config/api_calls";
import $ from "jquery";

import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";

import TextField from "../../../components/InputFields/TextField";
import SelectField from "../../../components/InputFields/SelectField";
import MutextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import "react-international-phone/build/index.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Select from "react-select";
import countryList from "react-select-country-list";
import PasswordStrengthBar from "react-password-strength-bar";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();

class Addagent extends Component {
  constructor() {
    super();
    this.state = {
      serviceData: [],
      select_service: "",
      errorMessage: "",
      serviceId: "",
      client_title: "",
      client_name: "",
      client_logo: "",
      client_comp: "",
      client_email: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      client_country: "United States",
      client_address: "",
      client_address2: "",
      client_phone: "",
      client_password: "",
      c_password: "",
      description: "",
      successMessage: "",
      tableLoader: true,
      domain: "",
      step: 1,
      passwordShown: false,
      confirmPasswordShown: false,
      notifyCheckBox: false,
      account_status: "",
      passwordRequired: false,
      errorName: "",
      errorStatus: "",
      errorClientCompany: "",
      errorClientEmail: "",
      errorClientPhone: "",
      errorClientAddress: "",
      errorClientCity: "",
      errorClientState: "",
      errorClientZip: "",
      errorClientCountry: "",
      errorClientPassword: "",
      errorCPassword: "",
      errorClientType: "",
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      address_autocomplete: true,
      address_validation: true,
      listMenuGroupData: [],
      selected_group_id: "",
      required_client_type: "",
    };
    this.phoneInputRef = createRef();
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands",
      )
      .sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
  }
  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };
  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    await this.getAgentPermissionData();
    await this.getClientMenuGroups();
  }

  getClientMenuGroups = async () => {
    this.setState({
      tableLoader: true,
    });
    const listClientMenuGroups = await getClientMenuActiveGroups(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("Client Menu Groups: ", listClientMenuGroups.data);
    if (
      listClientMenuGroups.data.status === 403 ||
      listClientMenuGroups.data.errors === "authentication missing" ||
      listClientMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientMenuGroups.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listClientMenuGroups.data.status === 200 &&
      listClientMenuGroups.data.message === "success"
    ) {
      const groupData = listClientMenuGroups.data.data;
      this.setState({
        listMenuGroupData: groupData,
        required_client_type: listClientMenuGroups.data.required_client_type,
        tableLoader: false,
      });
      this.autoSelectDefaultGroup(groupData);
    } else {
      //window.location.replace("/error");
    }
  };

  getAgentPermissionData = async () => {
    let acctno = auth.getAccount();

    let res = await getAgentPermissionData(
      acctno,
      auth.getToken(),
      auth.getEmail(),
    );
    // console.log("getAgentPermissionData: ", res.data);
    if (res.data.status === 200 && res.data.message === "success") {
      const permissionData = res.data.agentPermissionSettingsInfo?.data || {};
      this.setState({
        address_autocomplete: permissionData.address_autocomplete,
        address_validation: permissionData.address_validation,
      });
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  validateAndClearFieldError = (fieldName, fieldValue) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    const updates = {};

    switch (fieldName) {
      case "client_name":
        if (fieldValue !== "") {
          updates.errorName = "";
          updates.errorMessage = "";
        }
        break;
      case "client_comp":
        if (fieldValue !== "") {
          updates.errorClientCompany = "";
          updates.errorMessage = "";
        }
        break;
      case "client_email":
        if (fieldValue !== "" && ValidateEmail(fieldValue)) {
          updates.errorClientEmail = "";
          updates.errorMessage = "";
        }
        break;
      case "client_phone":
        if (fieldValue !== "" && this.isPhoneValid(fieldValue)) {
          updates.errorClientPhone = "";
          updates.errorMessage = "";
        }
        break;
      case "client_address":
        if (fieldValue !== "") {
          updates.errorClientAddress = "";
          updates.errorMessage = "";
        }
        break;
      case "client_city":
        if (fieldValue !== "") {
          updates.errorClientCity = "";
          updates.errorMessage = "";
        }
        break;
      case "client_state":
        if (fieldValue !== "") {
          updates.errorClientState = "";
          updates.errorMessage = "";
        }
        break;
      case "client_zip":
        if (fieldValue !== "") {
          updates.errorClientZip = "";
          updates.errorMessage = "";
        }
        break;
      case "client_country":
        if (fieldValue !== "") {
          updates.errorClientCountry = "";
          updates.errorMessage = "";
        }
        break;
      case "client_password":
        if (
          fieldValue !== "" &&
          fieldValue.length >= 8 &&
          passwordRegex.test(fieldValue)
        ) {
          updates.errorClientPassword = "";
          updates.errorMessage = "";
        }
        break;
      case "c_password":
        if (
          fieldValue !== "" &&
          fieldValue.length >= 8 &&
          fieldValue.trim() === this.state.client_password.trim()
        ) {
          updates.errorCPassword = "";
          updates.errorMessage = "";
        }
        break;
      case "account_status":
        if (fieldValue !== "") {
          updates.errorStatus = "";
          updates.errorMessage = "";
        }
        break;
      case "selected_group_id":
        if (fieldValue !== "") {
          updates.errorClientType = "";
          updates.errorMessage = "";
        }
        break;
      default:
        break;
    }

    if (Object.keys(updates).length > 0) {
      this.setState(updates);
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "client_name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "client_title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "client_comp") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    this.setState({
      [name]: value,
    });
    this.validateAndClearFieldError(name, value);
  };

  handleChangeStep = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeFile = async (event) => {
    this.setState({
      rate_deck_file: event.target.files[0],
    });
    //await this.sendFileData(event.target.files[0]);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        // console.log("addressComponents", addressComponents);
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";

        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });

        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        const newCity = city && city !== "" ? city : "";
        const newState = state && state !== "" ? state : "";
        const newZip = zipCode && zipCode !== "" ? zipCode : "";
        const newCountry = country && country !== "" ? country : "";
        const newAddress =
          streetAddress && streetAddress !== "" ? streetAddress : "";
        const newAddress2 = address2 && address2 !== "" ? address2 : "";

        this.setState({
          client_city: newCity,
          client_state: newState,
          client_zip: newZip,
          client_country: newCountry,
          client_address: newAddress,
          client_address2: newAddress2,
        });

        if (newAddress !== "")
          this.validateAndClearFieldError("client_address", newAddress);
        if (newCity !== "")
          this.validateAndClearFieldError("client_city", newCity);
        if (newState !== "")
          this.validateAndClearFieldError("client_state", newState);
        if (newZip !== "")
          this.validateAndClearFieldError("client_zip", newZip);
        if (newCountry !== "")
          this.validateAndClearFieldError("client_country", newCountry);
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  formClientUpdate = async () => {
    let {
      client_title,
      client_name,
      client_email,
      client_password,
      c_password,
      client_phone,
      client_address,
      client_address2,
      client_zip,
      client_country,
      client_city,
      client_state,
      client_comp,
      account_status,
      required_client_type,
      selected_group_id,
    } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      errorName: "",
      errorStatus: "",
      errorClientCompany: "",
      errorClientEmail: "",
      errorClientPhone: "",
      errorClientAddress: "",
      errorClientCity: "",
      errorClientState: "",
      errorClientZip: "",
      errorClientCountry: "",
      errorClientPassword: "",
      errorCPassword: "",
      errorClientType: "",
    });
    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (this.state.client_name === "") {
      this.setState({
        errorName: "error",
        errorMessage: "Full Name is required.",
      });
      is_validated = false;
    } else if (this.state.client_email === "") {
      this.setState({
        errorName: "",
        errorClientEmail: "error",
        errorMessage: "Email is required.",
      });
      is_validated = false;
    } else if (ValidateEmail(this.state.client_email) === false) {
      this.setState({
        errorName: "",
        errorClientEmail: "error",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.state.client_comp === "") {
      this.setState({
        errorClientEmail: "",
        errorClientCompany: "error",
        errorMessage: "Company is required.",
      });
      is_validated = false;
    } else if (this.state.client_phone === "") {
      this.setState({
        errorClientCompany: "",
        errorClientPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(this.state.client_phone)) {
      this.setState({
        errorClientCompany: "",
        errorClientPhone: "error",
        errorMessage: "Invalid phone format.",
      });
      is_validated = false;
    } else if (this.state.client_address === "") {
      this.setState({
        errorClientPhone: "",
        errorClientAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.client_country === "") {
      this.setState({
        errorClientAddress: "",
        errorClientCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (this.state.client_city === "") {
      this.setState({
        errorClientCountry: "",
        errorClientCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (this.state.client_zip === "") {
      this.setState({
        errorClientCity: "",
        errorClientZip: "error",
        errorMessage: "Zip is required.",
      });
      is_validated = false;
    } else if (this.state.client_state === "") {
      this.setState({
        errorClientZip: "",
        errorClientState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (this.state.passwordRequired && this.state.client_password === "") {
      this.setState({
        errorClientState: "",
        errorClientPassword: "error",
        errorMessage: "Password is required.",
      });
      is_validated = false;
    } else if (this.state.passwordRequired && this.state.client_password.length < 8) {
      this.setState({
        errorClientState: "",
        errorClientPassword: "error",
        errorMessage: "Use 8 characters or more for your password",
      });
      is_validated = false;
    } else if (this.state.passwordRequired && !passwordRegex.test(client_password)) {
      this.setState({
        errorClientState: "",
        errorClientPassword: "error",
        errorMessage:
          "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
      });
      is_validated = false;
    } else if (this.state.passwordRequired && this.state.c_password === "") {
      this.setState({
        errorClientPassword: "",
        errorCPassword: "error",
        errorMessage: "Confirm password is required.",
      });
      is_validated = false;
    } else if (this.state.passwordRequired && this.state.c_password.length < 8) {
      this.setState({
        errorClientPassword: "",
        errorCPassword: "error",
        errorMessage: "Use 8 characters or more for your confirm password",
      });
      is_validated = false;
    } else if (
      this.state.passwordRequired &&
      this.state.client_password.trim() !== this.state.c_password.trim()
    ) {
      this.setState({
        errorClientPassword: "",
        errorCPassword: "error",
        errorMessage: "Password and confirm password does not match.",
      });
      is_validated = false;
    } else if (
      this.state.listMenuGroupData &&
      this.state.listMenuGroupData.length > 0 &&
      required_client_type === 1 &&
      (!selected_group_id || selected_group_id === "")
    ) {
      this.setState({
        errorCPassword: "",
        errorClientType: "error",
        errorMessage: "Client Type is required.",
      });
      is_validated = false;
    } else if (this.state.account_status === "") {
      this.setState({
        errorClientType: "",
        errorStatus: "error",
        errorMessage: "Account Status is required.",
      });
      is_validated = false;
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (is_validated) {
      let apiResponce = await addNewClient(
        auth.getAccount(),
        auth.getToken(),
        client_title,
        client_name,
        client_email,
        client_password,
        client_phone,
        client_address,
        client_address2,
        client_zip,
        client_country,
        client_city,
        client_state,
        client_comp,
        account_status,
        this.state.notifyCheckBox.toString(),
        this.state.selected_group_id,
      );
      // console.log("Sub Agent Result:", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        this.setState({
          errorMessage: apiResponce.data.errors
            ? String(apiResponce.data.errors).replace(/,/g, "<br />")
            : "Address validation failed",
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "Success"
      ) {
        this.setState({
          successMessage: "Client added successfully.",
          tableLoader: false,
        });
        setTimeout(async function () {
          window.location.replace("/clients");
        }, 3000);
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "Account Already Exists"
      ) {
        this.setState({
          errorMessage:
            "Email already exists. Please try different email address.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  handleChangeCountry = (event) => {
    // console.log("event.label: ", event.label);
    const country = event?.label;
    this.setState({ client_country: country });
    this.validateAndClearFieldError("client_country", country);
  };

  handleGroupSelectionChange = (event) => {
    const selectedGroupId = event.target.value;
    this.setState({ selected_group_id: selectedGroupId });
  };

  autoSelectDefaultGroup = (groupData) => {
    if (groupData && groupData.length > 0) {
      const defaultGroup = groupData.find(
        (group) => group[5] === "Yes", // group[5] is is_default
      );

      if (defaultGroup) {
        const defaultGroupId = defaultGroup[4].toString(); // group[4] is the ID
        this.setState({
          selected_group_id: defaultGroupId,
        });
      }
    }
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const errorStyle = {
      control: (provided) => ({
        ...provided,
        borderColor: this.state.errorClientAddress ? "red" : "#d3d3d3",
        height: "57px",
      }),
    };
    return (
      <div className="nk-content " id="Services_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/clients")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Clients
                  </Link>
                  <Typography color="textPrimary" className="">
                    Add New Client
                  </Typography>
                </Breadcrumbs>
                {/*<h3 className="nk-block-title page-title">
                  <PageTitle name="Add New Services" />
                </h3>*/}
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-12">
              <div className="card card-bordered">
                <div className="card-inner">
                  <div className="card-head">
                    <h5 className="card-title">Enter client details below.</h5>
                  </div>
                  {this.state.errorMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.errorMessage,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.successMessage,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <br />
                  <form method="post" autoComplete="off" encType="multipart/form-data">
                    <div className="row g-4">
                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="client_name"
                          name="client_name"
                          type="text"
                          label="Full Name"
                          inputProps={{ maxLength: 20 }}
                          value={this.state.client_name}
                          onChange={this.handleChange}
                          helperText="Enter the name. Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorName === "error"}
                        />
                      </div>

                      <div className="form-group col-12 col-sm-6 col-lg-3">
                        <MutextField
                          id="client_title"
                          name="client_title"
                          type="text"
                          inputProps={{ maxLength: 20 }}
                          label="Title"
                          value={this.state.client_title}
                          onChange={this.handleChange}
                          helperText="Enter the title. Allowed characters: (&nbsp; _ &nbsp; - &nbsp; . &nbsp; &amp; &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                        />
                      </div>

                      <div className="form-group col-12 col-sm-6 col-lg-3">
                        <MutextField
                          required
                          id="client_comp"
                          name="client_comp"
                          type="text"
                          inputProps={{ maxLength: 100 }}
                          label="Company Name"
                          value={this.state.client_comp}
                          onChange={this.handleChange}
                          helperText="Enter the company name. Allowed characters: (&nbsp; _ &nbsp; . &nbsp; - &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientCompany === "error"}
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="client_email"
                          name="client_email"
                          type="email"
                          label="Email Address"
                          defaultValue={this.state.client_email}
                          onChange={this.handleChange}
                          helperText="Enter your email address here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientEmail === "error"}
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <ReactPhoneInput
                          country="us"
                          value={this.state.client_phone}
                          onChange={(value) => {
                            this.handleChange({
                              target: { name: "client_phone", value: `+${value}` }
                            });
                          }}
                          inputProps={{
                            name: "client_phone",
                            required: true,
                            label: "Phone Number",
                          }}
                          specialLabel="Phone Number *"
                          containerStyle={{ width: "100%" }}
                          inputStyle={{ width: "100%", height: "56px" }}
                          isValid={this.state.errorClientPhone !== "error"}
                        />
                      </div>

                        <div className="col-md-6 mt-3 mt-md-0 googleLocation-autocomplete-wrapper">
                          <div
                            className="nk-block-between-md g-4 mobile-address-toggle-wrap"
                            style={{
                              position: "absolute",
                              zIndex: 9999,
                              right: "13px",
                              top: "-15px",
                            }}
                          >
                            <div className="nk-block-head-content"></div>
                            {this.state.address_autocomplete === "Yes" && (
                              <div className="nk-block-head-content">
                                <ul className="nk-block-tools gx-3">
                                  <li>
                                    <a
                                      onClick={this.handleToggle}
                                      className="text-primary fs-11"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {toggleButtonText}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                          <div>
                            {this.state.address_autocomplete === "Yes" ? (
                              useGooglePlaces ? (
                                <>
                                  <GooglePlacesAutocomplete
                                    apiKey={
                                      process.env
                                        .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                    }
                                    selectProps={{
                                      value: this.state.client_address
                                        ? {
                                          label: this.state.client_address,
                                          value: this.state.client_address,
                                        }
                                        : null,
                                      onChange: this.handleAddressSelect,
                                      placeholder: this.state.client_address
                                        ? "Enter your address *"
                                        : "Enter your address *",
                                      styles: {
                                        ...errorStyle,
                                        input: (provided) => ({
                                          ...provided,
                                          color: "black",
                                          height: "47px",
                                        }),
                                        option: (provided) => ({
                                          ...provided,
                                          color: "black",
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          color: "black",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9,
                                        }),
                                      },
                                    }}
                                    className="googleLocation-autocomplete"
                                  />
                                  <p
                                    style={{
                                      fontSize: "0.75rem",
                                      fontWeight: 400,
                                      marginTop: "3px",
                                      color: "#526484",
                                      paddingLeft: "13px",
                                    }}
                                  >
                                    Enter your address here.
                                  </p>
                                </>
                              ) : (
                                <MutextField
                                  required
                                  id="client_address"
                                  name="client_address"
                                  type="text"
                                  label="PO Box Address"
                                  value={this.state.client_address}
                                  onChange={this.handleChange}
                                  helperText="Enter valid PO Box Address. i.e, PO Box Number, City, State Zip Code"
                                  variant="outlined"
                                  fullWidth
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{ maxLength: 100 }}
                                />
                              )
                            ) : (
                              // address_autocomplete === "No" → show PO Box only
                              <MutextField
                                required
                                id="client_address"
                                name="client_address"
                                type="text"
                                label="Address"
                                value={this.state.client_address}
                                onChange={this.handleChange}
                                helperText="Enter your address"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                  shrink: true,
                                  required: false,
                                }}
                              />
                            )}
                          </div>
                        </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="client_address2"
                          name="client_address2"
                          type="text"
                          label="Address 2"
                          value={this.state.client_address2}
                          onChange={this.handleChange}
                          helperText="If needed, enter additional address details, such as apartment number, suite, or unit."
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            required: false,
                          }}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="client_city"
                          name="client_city"
                          type="text"
                          label="City"
                          value={this.state.client_city}
                          onChange={this.handleChange}
                          helperText="Enter your city here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientCity === "error"}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="client_state"
                          name="client_state"
                          type="text"
                          label="State"
                          value={this.state.client_state}
                          onChange={this.handleChange}
                          helperText="Enter your state here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientState === "error"}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="client_zip"
                          name="client_zip"
                          type="text"
                          label="Zip"
                          value={this.state.client_zip}
                          onChange={this.handleChange}
                          helperText="Enter your zip here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientZip === "error"}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        {/* <Select
                          className="customStyle-country"
                          options={this.countryOptions}
                          value={{
                            label: this.state.client_country,
                            value: this.state.client_country,
                          }}
                          onChange={this.handleChangeCountry}
                          placeholder="Select a country"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: "56px",
                            }),
                          }}
                        /> */}
                        <Autocomplete
                          options={this.countryOptions}
                          getOptionLabel={(opt) => opt.label}
                          value={
                            this.state.client_country
                              ? this.countryOptions.find(
                                  (opt) =>
                                    opt.label === this.state.client_country ||
                                    opt.value === this.state.client_country,
                                ) || null
                              : null
                          }
                          onChange={(e, newValue) =>
                            this.handleChangeCountry(newValue || { label: "" })
                          }
                          renderInput={(params) => (
                            <MutextField
                              {...params}
                              required
                              label="Country"
                              variant="outlined"
                              fullWidth
                              error={this.state.errorClientCountry === "error"}
                              helperText="Select country"
                            />
                          )}
                        />
                        {/* <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-required">
                          Select country
                        </p> */}
                      </div>

                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-12"
                        style={{
                          padding: 0,
                          marginLeft: "3rem",
                          marginBottom: "1rem",
                        }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck3"
                            checked={this.state.passwordRequired}
                            onChange={() => {
                              const isChecked = !this.state.passwordRequired;
                              this.setState({
                                passwordRequired: isChecked,
                                client_password: "",
                                c_password: "",
                                errorClientPassword: "",
                                errorCPassword: "",
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck3"
                          >
                            Add Password
                          </label>
                        </div>
                      </div>

                      {this.state.passwordRequired && (
                        <>
                      <div
                        className="form-group col-md-6 confirm-password-group"
                        style={{ position: "relative" }}
                      >
                        <MutextField
                          required
                          id="client_password"
                          name="client_password"
                          type={this.state.passwordShown ? "text" : "password"}
                          label="Password"
                          defaultValue={this.state.client_password}
                          inputProps={{ maxLength: 30 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientPassword === "error"}
                        />
                        <a
                          style={{
                            left: "auto",
                            right: "10px",
                            top: "41px",
                            position: "absolute",
                            cursor: "pointer",
                          }}
                          tabIndex="-1"
                          onClick={this.togglePassword}
                          className="form-icon form-icon-right passcode-switch"
                          data-target="password"
                        >
                          {this.state.passwordShown ? (
                            <em className="icon ni ni-eye-off"></em>
                          ) : (
                            <em className="icon ni ni-eye"></em>
                          )}
                        </a>
                        <small
                          className="form-text confirm-password-helper-text"
                          style={{
                            // position: "absolute",
                            top: "69px",
                            left: "26px",
                            color: "#0000008a",
                            fontSize: "0.75rem",
                            fontWeight: "400",
                            fontFamily:
                              '"Roboto", "Helvetica", "Arial", sans-serif',
                            maxWidth: "95%",
                          }}
                        >
                          Password must be at least 8 characters, with
                          uppercase, lowercase, number & special character.
                        </small>
                        <div style={{ marginTop: "20px" }}>
                          <PasswordStrengthBar
                            password={this.state.client_password}
                          />
                        </div>
                      </div>

                      <div
                        className="form-group col-md-6 confirm-password-group"
                        style={{ position: "relative" }}
                      >
                        <MutextField
                          required
                          id="c_password"
                          name="c_password"
                          type={
                            this.state.confirmPasswordShown
                              ? "text"
                              : "password"
                          }
                          label="Confirm Password"
                          defaultValue={this.state.c_password}
                          inputProps={{ maxLength: 30 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorCPassword === "error"}
                        />
                        <a
                          style={{
                            left: "auto",
                            right: "10px",
                            top: "41px",
                            position: "absolute",
                            cursor: "pointer",
                          }}
                          tabIndex="-1"
                          onClick={this.toggleConfirmPassword}
                          className="form-icon form-icon-right passcode-switch"
                          data-target="password"
                        >
                          {this.state.confirmPasswordShown ? (
                            <em className="icon ni ni-eye-off"></em>
                          ) : (
                            <em className="icon ni ni-eye"></em>
                          )}
                        </a>

                        <small
                          className="form-text confirm-password-helper-text"
                          style={{
                            // position: "absolute",
                            marginLeft: "14px",
                            top: "69px",
                            left: "26px",
                            color: "#0000008a",
                            fontSize: "0.75rem",
                            fontWeight: "400",
                            fontFamily:
                              '"Roboto", "Helvetica", "Arial", sans-serif',
                            maxWidth: "95%",
                          }}
                        >
                          Confirm Password must be at least 8 characters, with
                          uppercase, lowercase, number & special character.
                          Confirm Password must match the Password.
                        </small>
                      </div>
                        </>
                      )}

                      {this.state.listMenuGroupData &&
                        this.state.listMenuGroupData.length > 0 && (
                          <div className="col-12 col-sm-6 col-lg-3">
                            <div className="form-control-group">
                              <MutextField
                                id="selected_group_id"
                                name="selected_group_id"
                                select
                                label={
                                  this.state.required_client_type == 1 ? (
                                    <>
                                      Select Client Type <span>*</span>
                                    </>
                                  ) : (
                                    "Select Client Type"
                                  )
                                }
                                value={this.state.selected_group_id}
                                onChange={this.handleChange}
                                SelectProps={{
                                  native: true, // Renders as basic <select>
                                }}
                                helperText="Select Client Type"
                                variant="outlined"
                                fullWidth
                                error={this.state.errorClientType === "error"}
                              >
                                <option key="group_default" value=""></option>
                                {this.state.listMenuGroupData &&
                                  this.state.listMenuGroupData.length > 0 &&
                                  this.state.listMenuGroupData.map(
                                    (group, index) => (
                                      <option
                                        key={`group_${index}`}
                                        value={group[4]}
                                      >
                                        {group[1]}{" "}
                                      </option>
                                    ),
                                  )}
                              </MutextField>
                            </div>
                          </div>
                        )}

                      <div className="form-group col-md-6">
                        <MutextField
                          id="account_status"
                          name="account_status"
                          select
                          label="Select Account Status *"
                          value={this.state.account_status}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          helperText="Select the account status here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorStatus === "error"}
                        >
                          <option key="" value=""></option>
                          <option key="5" value="active">
                            Active
                          </option>
                          <option key="10" value="inactive">
                            Inactive
                          </option>
                        </MutextField>
                      </div>

                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-3"
                        style={{ padding: 0, marginLeft: "3rem" }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck2"
                            checked={this.state.notifyCheckBox}
                            onChange={() => {
                              const isChecked = !this.state.notifyCheckBox;
                              this.setState({ notifyCheckBox: isChecked });
                              // console.log(
                              //   "Notify Checkbox Checked:",
                              //   isChecked
                              // );
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck2"
                          >
                            Notify Client
                          </label>
                        </div>
                      </div>

                      <div style={{ clear: "both" }}></div>
                      <hr />
                      <div className="form-group text-right col-md-12">
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled={this.state.disabled}
                          onClick={this.formClientUpdate}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                  {/*<StepWizard>
                    <Step1
                      handleChange={this.handleChangeStep}
                      values={values}
                    />
                    <Step2
                      handleChange={this.handleChangeStep}
                      values={values}
                    />
                  </StepWizard>*/}

                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Addagent);
